import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { calendarPickerClasses, pickersDayClasses, LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { inputAdornmentClasses, iconButtonClasses, TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { archerConstants } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import 'uuid/v4';

var _$concat, _datePickerDialogRoot;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var styles = {
  datePickerRoot: _defineProperty({
    maxHeight: '3rem',
    '& > div': {
      maxHeight: '3rem'
    },
    '& > input': {
      maxHeight: '3rem'
    }
  }, "& .".concat(inputAdornmentClasses['positionEnd']), {
    paddingRight: '3px'
  }),
  datePickerDialogRoot: (_datePickerDialogRoot = {}, _defineProperty(_datePickerDialogRoot, "& .".concat(calendarPickerClasses['root']), (_$concat = {}, _defineProperty(_$concat, "& .MuiPickersArrowSwitcher-root .MuiPickersArrowSwitcher-button", {
    color: 'text.secondary'
  }), _defineProperty(_$concat, "& [role=\"presentation\"] .".concat(iconButtonClasses['root']), {
    color: 'text.secondary'
  }), _$concat)), _defineProperty(_datePickerDialogRoot, "& .".concat(pickersDayClasses['selected']), {
    color: archerConstants.archerBackgroundPaper,
    backgroundColor: 'primary.main',
    '&:hover, &:focus, &:active': {
      backgroundColor: "".concat(archerConstants.archerPrimaryButtonHover, " !important")
    }
  }), _datePickerDialogRoot)
};
var ariaLabelPropertyName = 'aria-label';

var Datepicker = function Datepicker(_ref) {
  var _OpenPickerButtonProp;

  var disabled = _ref.disabled,
      disableFutureDates = _ref.disableFutureDates,
      shouldDisableDate = _ref.shouldDisableDate,
      disableToolbar = _ref.disableToolbar,
      disablePastDates = _ref.disablePastDates,
      label = _ref.label,
      locale = _ref.locale,
      onChange = _ref.onChange,
      value = _ref.value,
      fullWidth = _ref.fullWidth,
      margin = _ref.margin,
      menuRef = _ref.menuRef,
      error = _ref.error,
      helperText = _ref.helperText,
      readOnly = _ref.readOnly,
      required = _ref.required,
      sxTextField = _ref.sxTextField,
      sxPopper = _ref.sxPopper;
  moment.locale(locale);
  var datePickerRoot = styles.datePickerRoot,
      datePickerDialogRoot = styles.datePickerDialogRoot;
  var format = moment().localeData().longDateFormat('L');
  var baseProps = {
    // maxDateMessage: maxDateMessage,
    // minDateMessage: minDateMessage,
    OpenPickerButtonProps: (_OpenPickerButtonProp = {}, _defineProperty(_OpenPickerButtonProp, ariaLabelPropertyName, label), _defineProperty(_OpenPickerButtonProp, "color", 'primary'), _OpenPickerButtonProp),
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({
        readOnly: readOnly,
        variant: "filled",
        sx: [datePickerRoot, sxTextField],
        fullWidth: fullWidth,
        margin: margin,
        required: required,
        error: error,
        helperText: helperText
      }, _objectSpread(_objectSpread({}, params), {}, _defineProperty({}, ariaLabelPropertyName, label))));
    },
    leftArrowButtonText: 'left',
    rightArrowButtonText: 'right',
    disableFuture: disableFutureDates,
    disablePast: disablePastDates,
    shouldDisableDate: shouldDisableDate,
    // invalidDateMessage: invalidDate,
    disabled: disabled,
    showToolbar: !disableToolbar,
    inputFormat: format,
    label: label,
    onChange: onChange,
    value: value,
    readOnly: readOnly
  };
  return /*#__PURE__*/React.createElement(LocalizationProvider, {
    dateAdapter: AdapterMoment
  }, /*#__PURE__*/React.createElement(DatePicker, _objectSpread(_objectSpread({}, baseProps), {}, {
    PopperProps: {
      sx: [datePickerDialogRoot, sxPopper],
      ref: menuRef
    }
  })));
};

Datepicker.defaultProps = {
  disabled: false,
  disablePastDates: false,
  disableFutureDates: false,
  shouldDisableDate: function shouldDisableDate() {
    return false;
  },
  locale: 'en-US',
  margin: 'normal',
  readOnly: false,
  required: false
};
Datepicker.displayName = 'Datepicker';
export { Datepicker };